const styles = (theme) => ({
  container: {
    borderRadius: '2px',
    boxShadow: `0px 0px 4px ${theme.HeaderDefaultTextColor}`,
    padding: 14,
    marginBottom: 20,
  },
  completeMarking: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    height: '100%'
  },
  completeMarkingLabel: {
    color: theme.TextColor,
    paddingBottom: 16
  },
  closeButton: {
    width: '42%'
  },
  InputLabelProps: {
    color: theme.iconColor,
    transform: 'translate(14px, 13px) scale(1)',
  },
  selectFilterClass: {
    direction: "column",
    marginRight: 8,
    width: "56%",
    '&>div': {
      flex: 1,
      width: "56%"
    }
  },
  locationName: {
    width: "75%",
    marginBottom: 0,
  },
  highlightedCard: {
    border: `2px solid ${theme.HeaderSelectedText}`,
    boxShadow: "0 14px 28px rgba(0,0,0,0.25)",
  },
});

export default styles;
